import {
    DashboardTopSearchtermRequest,
    DashboardTopSearchtermResponse,
    MultiSearchtermRequest,
    MultiSearchtermResponse,
} from '../types/api/dashboard/DashboardTopSearchterms';
import axios, {AxiosResponse} from 'axios';
import {handleError} from './errorHandling';
import {DashboardTableDataRequest, DashboardTableDataResponse} from '../types/api/dashboard/DashboardTable';
import {FilterTableDataRequest, TopFilterData} from '../types/api/dashboard/DashboardFilters';

export function getDashboardTopTenSearchtermData(data: DashboardTopSearchtermRequest): Promise<AxiosResponse<DashboardTopSearchtermResponse[]>> {
    const {channel, ...queryParams} = data;
    return axios
        .get(`dashboard/topSearchterms/${channel}`, {
            params: queryParams,
        })
        .catch(handleError('error:loadingOfTop10SearchtermsFailed'));
}

export function getDashboardTableData(
    firstRange: DashboardTableDataRequest,
    secondRange: DashboardTableDataRequest
): Promise<Array<AxiosResponse<DashboardTableDataResponse>>> {
    return axios.all([getDashboardTableDataSingleRange(firstRange), getDashboardTableDataSingleRange(secondRange)]);
}

export function getDashboardTableDataSingleRange(data: DashboardTableDataRequest): Promise<AxiosResponse<DashboardTableDataResponse>> {
    const {channel, ...queryParams} = data;
    return axios
        .get(`dashboard/overview/${channel}`, {
            params: queryParams,
        })
        .catch(handleError('error:loadingOfOverviewDataFailed'));
}

export function multiWordSearchesPerChannel(data: MultiSearchtermRequest): Promise<AxiosResponse<MultiSearchtermResponse>> {
    const {channel, ...queryParams} = data;
    return axios
        .get(`dashboard/multiWordSearches/${channel}`, {
            params: queryParams,
        })
        .catch(handleError('error:loadingOfMultiwordSearchesPerChannelFailed'));
}

export function getTopFilters(data: FilterTableDataRequest): Promise<AxiosResponse<TopFilterData>> {
    const {channel, ...queryParams} = data;
    return axios
        .get(`dashboard/topFilters/${channel}`, {
            params: queryParams,
        })
        .catch(handleError('error:loadingOfTopFiltersFailed'));
}



// WEBPACK FOOTER //
// ./src/apis/DashboardAPI.ts